<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <el-row>
      <el-col :span="4" class="item-label">船龄</el-col>
      <el-col :span="8">
          <el-input v-model="ship_info.ship_age" @input="inputShipAge" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="shipAgeValue" placeholder="请选择船龄" class="w-50" @change="handleSelectedShipAge" filterable >
          <el-option v-for="(item, index) in shipAgeOptions" :key="index" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">船舶种类</el-col>
      <el-col :span="8">
        <el-input v-model="ship_info.ship_type" @input="inputShipType" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="shipTypeValue" placeholder="请选择" class="w-50" @change="handleSelectedShipType" filterable >
          <el-option v-for="(item, index) in shipTypeOptions" :key="index" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">船籍港</el-col>
      <el-col :span="8">
        <el-input v-model="ship_info.port_of_registry" @input="inputPortOfRegistry"></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="portOfRegistryValue" placeholder="请选择船籍港" class="w-50" @change="handleSelectedPortOfRegistry" filterable  >
          <el-option v-for="(item, index) in portOfRegistryOptions" :key="index" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">航行区域</el-col>
      <el-col :span="8">
        <el-input v-model="ship_info.sailing_area" @input="inputSailingArea"></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="sailingAreaValue" placeholder="请选择" class="w-50" @change="handleSelectedSailingArea" filterable >
          <el-option v-for="(item, index) in sailingAreaOptions" :key="index" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">总吨</el-col>
      <el-col :span="8">
        <el-input v-model="ship_info.total_tons" @input="inputTotalTons" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model="ship_info.total_tons" @input="inputTotalTons" placeholder="请输入"  class="w-50"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">载重吨</el-col>
      <el-col :span="8">
        <el-input v-model="ship_info.dwt" @input="inputDWT" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model="ship_info.dwt" @input="inputDWT" placeholder="请输入"  class="w-50"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button :loading="get_ship_info_loading" type="primary" @click="handleGetShipInfo">获取船舶信息</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import { fetchDictList } from '@/api/common'
  import { getShipByName } from '@/api/ship'
  export default {
    name: 'ship-info-input',
    props: {
      is_disabled:{
        default:true
      },
      ship_age:{
        default:''
      },
      ship_type:{
        default:''
      },
      port_of_registry:{
        default:''
      },
      sailing_area:{
        default:''
      },
      dwt:{
        default:''
      },
      total_tons:{
        default:''
      },
      ship_name: {
        default: ''
      }
    },
    data() {
      return {
        dialogVisible: false,
        disabled: this.is_disabled,
        // 船龄选项
        shipAgeOptions: [],
        shipAgeValue: null,

        // 船籍港选项
        portOfRegistryOptions: [{"value": '博罗'}, {"value": '常德'}, {"value": '常州'}, {"value": '东莞'}, {"value": '佛山'},
          {"value": '抚州'}, {"value": '广西'}, {"value": '广州'}, {"value": '贵港'}, {"value": '桂平'}, {"value": '横县'},
          {"value": '黄冈'}, {"value": '惠州'}, {"value": '吉安'}, {"value": '嘉兴'}, {"value": '江门'}, {"value": '来宾'},
          {"value": '柳城'}, {"value": '柳州'}, {"value": '南昌'}, {"value": '南宁'}, {"value": '青岛'}, {"value": '清远'},
          {"value": '汕头'}, {"value": '韶关'}, {"value": '深圳'}, {"value": '顺德'}, {"value": '台州'}, {"value": '泰州'},
          {"value": '藤县'}, {"value": '芜湖'}, {"value": '梧州'}, {"value": '扬州'}, {"value": '宜春'}, {"value": '岳阳'},
          {"value": '云浮'}, {"value": '肇庆'}, {"value": '浙江'}, {"value": '中山'}, {"value": '周口'}, {"value": '珠海'}],
        portOfRegistryValue: null,

        // 船型选项
        shipTypeOptions: [],
        shipTypeValue: null,

        // 航行区域选项
        sailingAreaOptions: [],
        sailingAreaValue: null,
        ship_info: {
          ship_age: this.ship_age,
          ship_type: this.ship_type,
          port_of_registry: this.port_of_registry,
          sailing_area: this.sailing_area,
          dwt: this.dwt,
          total_tons: this.total_tons,
        },
        get_ship_info_loading: false,
      }
    },
    watch: {
      'is_disabled': function (val){
        this.disabled = val
      },
      'ship_age': function(val){
        this.ship_info.ship_age = val
      },
      'ship_type': function(val){
        this.ship_info.ship_type = val
      },
      'port_of_registry': function(val){
        this.ship_info.port_of_registry = val
      },
      'sailing_area': function(val){
        this.ship_info.sailing_area = val
      },
      'dwt': function(val){
        this.ship_info.dwt = val
      },
      'total_tons': function(val){
        this.ship_info.total_tons = val
      },
    },
    methods:{
      showDialog(){
        this.dialogVisible = true
      },
      loadData(){
        let p = []
        p.push(fetchDictList({type: 'ship.type'}))
        p.push(fetchDictList({type: 'ship.sailing_area'}))
        Promise.all(p).then(resp => {
          // 生成船龄选项
          let oDate = new Date();
          const startYear = parseInt(oDate.getFullYear())
          const yearSpan = 50
          const endYear = startYear - yearSpan
          for (let i=startYear; i > endYear; i--){
            this.shipAgeOptions.push({
              "value":i.toString()
            })
          }

          // 获取船型选项
          let tempShipTypeOptions = Object.assign([], resp[0])
          this.shipTypeOptions =[]
          for (let o of tempShipTypeOptions){
            this.shipTypeOptions.push({
              "value":o.value
            })
          }

          // 获取航行区域选项
          let tempSailingAreaOptions = Object.assign([], resp[1])
          this.sailingAreaOptions =[]
          for (let o of tempSailingAreaOptions){
            this.sailingAreaOptions.push({
              "value":o.value
            })
          }
        })
      },
      // 处理船龄变更
      handleSelectedShipAge(value){
        let selectedItem = this.shipAgeOptions.find(item => {
          return(item.value === value)
        })
        if(selectedItem) {
          this.inputShipAge(selectedItem.value)
        } else {
          this.$message.error("选择出错")
        }
      },
      // 处理船型变更
      handleSelectedShipType(value){
        let selectedItem = this.shipTypeOptions.find(item => {
          return(item.value === value)
        })
        if(selectedItem) {
          this.inputShipType(selectedItem.value)
        } else {
          this.$message.error("选择出错")
        }
      },
      // 处理船籍港变更
      handleSelectedPortOfRegistry(value){
        let selectedItem = this.portOfRegistryOptions.find(item => {
          return(item.value === value)
        })
        if(selectedItem) {
          this.inputPortOfRegistry(selectedItem.value)
        } else {
          this.$message.error("选择出错")
        }
      },
      // 处理航行区域变更
      handleSelectedSailingArea(value){
        let selectedItem = this.sailingAreaOptions.find(item => {
          return(item.value === value)
        })
        if(selectedItem) {
          this.inputSailingArea(selectedItem.value)
        } else {
          this.$message.error("选择出错")
        }
      },

      // 变更父组件数据
      emitUpdate(){
        this.$emit('change', this.ship_info)
      },
      inputShipAge(val){
        this.ship_info.ship_age = val
        this.emitUpdate()
      },
      inputShipType(val){
        this.ship_info.ship_type = val
        this.emitUpdate()
      },
      inputPortOfRegistry(val){
        this.ship_info.port_of_registry = val
        this.emitUpdate()
      },
      inputSailingArea(val){
        this.ship_info.sailing_area = val
        this.emitUpdate()
      },
      inputDWT(val){
        this.ship_info.dwt = val
        this.emitUpdate()
      },
      inputTotalTons(val){
        this.ship_info.total_tons = val
        this.emitUpdate()
      },
      handleGetShipInfo() {
        if (!this.ship_name) {
          this.$message.error('请先填写船名')
          return
        }
        this.get_ship_info_loading = true
        getShipByName({'name': this.ship_name}).then(res => {
          this.get_ship_info_loading = false
          if (res.construct_date) {
            this.ship_info.ship_age = res.construct_date.substr(0, 4)
          } else {
            this.ship_info.ship_age = '0'
          }
          this.ship_info.ship_type = res.type_name
          this.ship_info.port_of_registry = res.reg_port ? res.reg_port : ''
          this.ship_info.sailing_area = res.airworthiness_area_name
          this.ship_info.total_tons = res.gross_tonnage
          this.ship_info.dwt = res.load_tonnage ? res.load_tonnage : 0
          this.emitUpdate()
        }).catch(err => {
          this.get_ship_info_loading = false
          this.$message.error(err)
        })
      }
    },
    created() {
      this.loadData()
    }
  }

</script>

<style scoped>
>>> .el-dialog {
  width:96%;
}

.item-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
